import { hardBreak as hardBreakFactory } from '../../next-schema/generated/nodeTypes';

/**
 * @name hardBreak_node
 */

export var hardBreak = hardBreakFactory({
  parseDOM: [{
    tag: 'br'
  }],
  toDOM: function toDOM() {
    return ['br'];
  }
});